export enum AssetType {
    CoverPhoto = "CoverPhoto",
    SupportingDocument = "SupportingDocument",
    IdDocument = "IdDocument"
}